<template>
  <div class="invoiceStore clearfix">
    <div class="headBox row">
      <div class="col-12 col-md-8">
        <h2>开票申请</h2>
        <p class="description">— 已支付已发货的还未申请的订单方可开票</p>
      </div>
      <div class="col-12 col-md-4 text-right">
        <button v-if="step===1" @click="xiayibuFun()" type="button" class="btn btn-primary">
          下一步<span v-if="checkArr.length!==0">（已选{{checkArr.length}}个）</span>
        </button>
        <i class="iconfont icon-jiazai xuanzhuan" style="font-size:30px;color:#6E00FF;" v-if="step===2 && calculateLoading"></i>
        <button v-if="step===2 && !calculateLoading" type="button" @click="shangyibuFun()" class="btn btn-primary">上一步</button>
        <button v-if="step===2 && !calculateLoading && calculateTaxTotalTrue!==0" type="button" @click="apiInvoiceapply()" class="btn btn-success"><i v-if="isStoreLoading" class="iconfont icon-jiazai xuanzhuan"></i>支付</button>
        <button v-if="step===2 && !calculateLoading && calculateTaxTotalTrue===0" class="btn btn-secondary" disabled>税费为0，无法支付</button>
      </div>
    </div>
    <div v-show="step===2" class="mainBox" ref="invoiceStoreScroll">
      <div class="checkBox row">
        <div class="col-12">
          <h5>基础信息</h5>
          <p class="content"><small>— 购买金额不包含税费，如要开票需额外支付税款</small></p>
          <hr style="border-color: #DEE2E6;">
        </div>
        <div class="col-12 col-md-4 mb-3">
          票面金额：
          <span class="text-danger" v-if="step===2 && !calculateLoading">￥{{calculateTaxPrice}}</span>
          <span class="text-danger" v-if="step===2 && calculateLoading">计算中...</span>
          &nbsp;&nbsp;，&nbsp;&nbsp;
          税额计算：
          <span class="text-danger" v-if="step===2 && !calculateLoading">￥{{calculateTaxTotal}}</span>
          <span class="text-danger" v-if="step===2 && calculateLoading">计算中...</span>
        </div>
      </div>
      <div class="biaodanBox mb-4 row" v-if="!calculateLoading">
        <div class="col-12 mb-3">
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="invoiceFrom" id="inlineRadio1" name="invoiceFrom" :value="1">
              <label class="form-check-label" for="inlineRadio1">个人</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="invoiceFrom" id="inlineRadio2" name="invoiceFrom" :value="2">
              <label class="form-check-label" for="inlineRadio2">企业</label>
            </div>
          </div>
          <div v-if="invoiceFrom===1" class="form-group mb-0">
            <label>名称</label>
            <input type="text" v-model="headPerson" class="form-control">
          </div>
          <div v-if="invoiceFrom===2" class="form-group mb-2">
            <label>发票抬头</label>
            <input type="text" v-model="headTitle" class="form-control">
          </div>
          <div v-if="invoiceFrom===2" class="form-group mb-2">
            <label>信用代码</label>
            <input type="text" v-model="headCode" class="form-control">
          </div>
          <div v-if="invoiceFrom===2" class="form-group mb-2">
            <label>开 户 行 </label>
            <input type="text" v-model="headBank" class="form-control">
          </div>
          <div v-if="invoiceFrom===2" class="form-group mb-2">
            <label>银行账号</label>
            <input type="text" v-model="headBankcode" class="form-control">
          </div>
          <div v-if="invoiceFrom===2" class="form-group mb-2">
            <label>注册电话</label>
            <input type="text" v-model="headRegisterphone" class="form-control">
          </div>
          <div v-if="invoiceFrom===2" class="form-group mb-0">
            <label>注册地址</label>
            <input type="text" v-model="headRegisteraddress" class="form-control">
          </div>
        </div>
        <div class="col-12">
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="invoiceType" name="invoiceType" id="inlineRadio3" :value="1">
              <label class="form-check-label" for="inlineRadio3">电子普通发票(在线下载)</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" v-model="invoiceType" name="invoiceType" id="inlineRadio4" :value="2">
              <label class="form-check-label" for="inlineRadio4">纸质增值税专用发票 </label>
            </div>
          </div>
          <div v-if="invoiceType===2" class="form-group mb-2">
            <label>收件人</label>
            <input type="text" v-model="expressName" class="form-control">
          </div>
          <div v-if="invoiceType===2" class="form-group mb-2">
            <label>收件号码</label>
            <input type="text" v-model="expressPhone" class="form-control">
          </div>
          <div v-if="invoiceType===2" class="form-group mb-2">
            <label>收件地址</label>
            <input type="text" v-model="expressAddress" class="form-control">
          </div>
        </div>
      </div>
      <div class="detailInfo row" v-if="!calculateLoading">
        <div class="col-12">
          <h5>包含内容</h5>
          <p class="content"><small>— 包含商品内容，请仔细核对，建议按需开票</small></p>
        </div>
        <div class="col-12">
          <table class="table table-bordered">
            <thead>
            <tr class="bg-white">
              <td scope="col">编号</td>
              <td scope="col">商品</td>
              <td scope="col">面额<small> / 税率</small></td>
              <td class="text-right" scope="col">税额</td>
            </tr>
            </thead>
            <tbody v-for="(app,index) in calculateData" :key="index">
            <tr v-for="(apps,indexs) in app" :key="indexs">
              <td class="bg-white" v-if="indexs===0" :rowspan="app.length">
                {{apps.order_no?'NO.'+apps.order_no:apps.bills_no}}
              </td>
              <td>
                {{apps.name}} × {{apps.num*1 - apps.tuiNumber*1}}
              </td>
              <td>
                {{apps.currencyType==='1'?'￥':''}}{{apps.currencyType==='2'?'$':''}}{{apps.kaipiaoPrice}}<small> / {{apps.tax_rate}}%</small>
              </td>
              <td v-if="apps.taxFree==='0'" class="text-right text-primary">
                {{apps.currencyType==='1'?'￥':''}}{{apps.currencyType==='2'?'$':''}}{{apps.shuiePrice}}
              </td>
              <td v-else class="text-right text-danger">
                <small>免税率</small>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--商品列表-->
    <div v-show="step===1" class="mainBox" ref="invoiceStoreScroll">
      <div class="searchBox">
        <div class="box riqi">
          <div class="form-group m-0">
            <label>日期选择</label>
            <div class="zujian">
              <date-range-picker
                ref="picker"
                :opens="opens"
                :locale-data="localeData"
                :minDate="minDate" :maxDate="maxDate"
                :singleDatePicker="singleDatePicker"
                :timePicker="timePicker"
                :timePicker24Hour="timePicker24Hour"
                :showWeekNumbers="showWeekNumbers"
                :showDropdowns="showDropdowns"
                :autoApply="autoApply"
                v-model="dateRange"
                @update="updateValues"
                @toggle="logEvent('event: open', $event)"
                @start-selection="logEvent('event: startSelection', $event)"
                @finish-selection="logEvent('event: finishSelection', $event)"
                :linkedCalendars="linkedCalendars"
              >
              </date-range-picker>
              <i @click="clearDateTangeFun" class="iconfont icon-guanbi clear"></i>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="form-group m-0">
            <label>订单/出库单号</label>
            <input @input="initData(true)" v-model="no" type="text" class="form-control">
          </div>
        </div>
        <div class="box">
          <div class="form-group m-0">
            <label>包含商品名称</label>
            <input @input="initData(true)" v-model="goodsName" type="text" class="form-control">
          </div>
        </div>
      </div>
      <div class="jiazaiBox" v-show="intLoading">
        <div class="spinner-border text-secondary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="checkGoodsBox" v-show="!intLoading">
        <div v-show="!is_loading" class="box yuanjiao">
          <div class="table-responsive-sm">
            <table class="table table-striped table-bordered">
              <thead>
              <tr class="active">
                <td scope="col">#</td>
                <td scope="col">日期</td>
                <td scope="col">编号</td>
                <td scope="col">商品</td>
                <td scope="col">面额<small> / 税率</small></td>
                <td class="text-right" scope="col">税额</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(app,index) in data" :key="index" class="huanchongZhong cursor" @click="addOrder(app.id)">
                <td class="align-middle">
                  <input :disabled="app.payment_proceeds==='26'" :value="app.id" v-model="checkArr" type="checkbox">
                </td>
                <td>
                  {{app.bill_date_str}}
                </td>
                <td>
                  {{app.order_no?'NO.'+app.order_no:app.bills_no}}
                </td>
                <td>
                  {{app.name}} × {{app.num*1 - app.tuiNumber*1}}
                </td>
                <td>
                  {{app.currencyType==='1'?'￥':''}}{{app.currencyType==='2'?'$':''}}{{app.kaipiaoPrice}}<small> / {{app.tax_rate}}%</small>
                </td>
                <td v-if="app.taxFree==='0'" class="text-right text-primary">
                  {{app.currencyType==='1'?'￥':''}}{{app.currencyType==='2'?'$':''}}{{app.shuiePrice}}
                </td>
                <td v-else class="text-right text-danger">
                  <small>免税率</small>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="description text-center">
            <br>
            <br>
            <div v-show='isLoading && page!==1' class='dynamicMessage'>
              <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
            </div>
            <div v-show='isNodata' class='dynamicMessage'>
              — 没有更多了 —
            </div>
            <div v-show='isError' class='dynamicMessage'>
              — 请求失败 —
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div>
    <ui-pay :closeRightBoxFun="closeRightBoxFun" :parms="parms" v-if="purchaseBox" :closePurchaseBox="closePurchaseBox"></ui-pay>
  </div>
</template>

<script>
  // import { EventBus } from '@/util/eventBus';
  import generalMix from '@/util/mix/general';
  import resultCommons from '@/util/resultcommons';
  import commons from '@/util/commons';
  import uiPay from '@/components/common/invoicePay';
  import DateRangePicker from 'vue2-daterange-picker';
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

  export default {
    name: 'invoiceStore',
    props:['closeRightBoxFun'],
    mixins: [generalMix],
    data () {
      return {
        step:1,
        title:'',
        code:'',
        content:'',
        // 筛选
        no: '',
        goodsName: '',
        // 时间筛选
        opens: 'right',
        minDate: null, // 最小时间
        maxDate: null, // 最大时间
        singleDatePicker: false, // 范围为false
        timePicker: false, // 是否选择小时和分钟
        timePicker24Hour: true, // 24小时制
        showWeekNumbers: true, // 左侧显示周数
        showDropdowns: true, // 显示下拉选择 快速选择年份和月份
        autoApply: true, // 第二次点击自动选择
        dateRange: {
          startDate: null,
          endDate: null
        }, // 时间值
        linkedCalendars: true, // 每个日历都有单独的导航
        localeData: {
          firstDay: 1,
          format: 'yyyy-mm-dd',
          separator: ' 至 ',
          applyLabel: '确定',
          cancelLabel: '取消',
          daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
          monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
        },
        // 分页
        data: [], // 数据队列
        allPage: 1, // 总页数
        allNumber: 0,
        page: 1, // 当前页数
        is_empty: false, // 是否为空数据(没有任何数据)
        isNodata: false, // 没有更多了
        isLoading: false, // 是否请求中
        isError: false, // 请求失败
        intLoading: true, // 初始化加载
        is_loading:false,
        checkArr:[],
        priceArr:[],
        isStoreLoading:false,
        isSuccess:false,
        // 计算结果
        calculateLoading:true,
        calculateData:[],
        calculateTaxTotal:0,
        calculateTaxPrice:0,
        calculateTaxTotalTrue:0,
        // 提交
        invoiceFrom:1,
        invoiceType:1,
        headTitle:'',
        headCode:'',
        headBank:'',
        headBankcode:'',
        headRegisterphone:'',
        headRegisteraddress:'',
        headPerson:'',
        expressName:'',
        expressPhone:'',
        expressAddress:'',
        // 支付内容
        purchaseBox: false
      }
    },
    computed:{
      priceTotal() {
        let price = 0;
        this.priceArr.forEach(app=>{
          price += app * 1;
        });
        return price;
      },
      whereObj() {
        return {
          page: this.page,
          no: this.no,
          goodsName: this.goodsName,
          startTime: commons.getData(this.dateRange.startDate),
          endTime: commons.getData(this.dateRange.endDate)
        };
      }
    },
    methods:{
      clearDateTangeFun() {
        if(this.dateRange.startDate || this.dateRange.endDate){
          this.dateRange = {startDate: null, endDate: null};
          this.initData();
        }
      },
      // 更新了日期
      updateValues() {
        this.initData();
      },
      logEvent(message, event) {
      },
      // 显示详情
      closePurchaseBox() {
        this.purchaseBox = false;
      },
      apiInvoiceapply() {
        // eslint-disable-next-line no-unused-vars
        let bool = false;
        // 合法性判断
        if(this.checkArr.length <= 0){
          bool = true;
          this.$message.showMsgBox({ type: 'warning', content: '请选择开票订单' });
        }
        if(this.invoiceFrom === 1){
          if(this.headPerson === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '抬头名称必填' });
          }
        }else{
          if(this.headTitle === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '发票抬头必填' });
          }
          if(this.headCode === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '信用代码必填' });
          }
          if(this.headBank === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '开户行必填' });
          }
          if(this.headBankcode === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '银行账号必填' });
          }
          if(this.headRegisterphone === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '注册电话必填' });
          }
          if(this.headRegisteraddress === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '注册地址必填' });
          }
        }
        if(this.invoiceType === 2){
          if(this.expressName === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '收件人必填' });
          }
          if(this.expressPhone === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '收件号码 必填' });
          }
          if(this.expressAddress === ''){
            bool = true;
            this.$message.showMsgBox({ type: 'warning', content: '收件地址 必填' });
          }
        }
        if(!bool){
          this.parms = {
            invoiceArr:this.checkArr,
            calculateTaxTotal:this.calculateTaxTotal,
            calculateTaxPrice:this.calculateTaxPrice,
            invoiceFrom:this.invoiceFrom,
            invoiceType:this.invoiceType,
            headTitle:this.headTitle,
            headCode:this.headCode,
            headBank:this.headBank,
            headBankcode:this.headBankcode,
            headRegisterphone:this.headRegisterphone,
            headRegisteraddress:this.headRegisteraddress,
            headPerson:this.headPerson,
            expressName:this.expressName,
            expressPhone:this.expressPhone,
            expressAddress:this.expressAddress
          };
          this.purchaseBox = true;
        }
      },
      xiayibuFun() {
        if(this.checkArr.length === 0){
          this.$message.showMsgBox({
            type: 'warning',
            content: '请选择开票订单'
          });
        }else{
          // 请求
          this.calculateLoading = true;
          // 获取计算结果
          this.step = 2;
          resultCommons.apiWarehousebillsgoodscalculate(this,{invoiceArr:this.checkArr}).then(ob=>{
            if(ob.state === 200){
              this.calculateData = ob.data.orderList;
              this.calculateTaxTotal = ob.data.taxTotal;
              this.calculateTaxTotalTrue = ob.data.taxTotalTrue;
              this.calculateTaxPrice = ob.data.priceTotal;
              this.calculateLoading = false;
            }else{
              this.$message.showMsgBox({
                type: 'warning',
                content: ob.message
              });
            }
          });
        }
      },
      shangyibuFun() {
        this.step = 1;
      },
      addOrder(id) {
        const index = this.checkArr.indexOf(id);
        const info = this.data.find(app=>{
          return app.id === id;
        });
        if(info.payment_proceeds !== '26'){
          // 这里将直接作用与根
          if (index > -1) {
            // 存在则剔除
            this.priceArr.splice(index, 1);
            this.checkArr.splice(index, 1);
          }  else {
            // 不存在且没有到上限
            this.priceArr.push(info.shuiePrice);
            this.checkArr.push(id);
          }
        }
      },
      // 状态切换
      loadingFun(bool) {
        if (bool === 1) {
          // 加载中
          this.isNodata = false;
          this.isError = false;
          this.isLoading = true;
        } else if (bool === 2) {
          // 关闭所有
          this.isNodata = false;
          this.isError = false;
          this.isLoading = false;
        } else if (bool === 3) {
          // 没有更多了
          this.isNodata = true;
          this.isError = false;
          this.isLoading = false;
        } else {
          // 请求失败了
          this.isNodata = false;
          this.isError = true;
          this.isLoading = false;
        }
      },
      scroll(that, node) {
        node.onscroll = () => {
          // 距离底部200px时加载一次
          const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 50;
          // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
          if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
            const whereJson = that.whereObj;
            resultCommons.apiWarehousebillsgoodslists(that, whereJson).then((ob) => {
              console.log(ob, this.page);
            });
          }
        };
      },
      initData(bool = false){
        // 判断是否有时间筛选
        if(bool){
          this.intLoading = true;
        }
        // 执行搜索
        this.loadingFun(2);
        // 初始化
        this.data = [];
        this.allPage = 1;
        this.page = 1;
        // 不为空
        this.is_empty = false;
        const whereJson = this.whereObj;
        // 执行搜索
        resultCommons.apiWarehousebillsgoodslists(this, whereJson).then((ob) => {}).then(app=>{
          if(bool){
            this.intLoading = false;
          }
        });
      }
    },
    components: {
      'ui-pay':uiPay,
      DateRangePicker
    },
    created() {
      this.headTitle = this.localUser.invoiceInfo.title;
      this.headCode = this.localUser.invoiceInfo.code;
      this.headBank = this.localUser.invoiceInfo.bank;
      this.headBankcode = this.localUser.invoiceInfo.bankCode;
      this.headRegisterphone = this.localUser.invoiceInfo.registerPhone;
      this.headRegisteraddress = this.localUser.invoiceInfo.registerAddress;
      this.headRegisteraddress = this.localUser.invoiceInfo.registerAddress;
      this.headPerson = this.localUser.invoiceInfo.person;
      this.expressName = this.localUser.invoiceInfo.mailName;
      this.expressPhone = this.localUser.invoiceInfo.mailPhone;
      this.expressAddress = this.localUser.invoiceInfo.mailAddress;
    },
    mounted() {
      this.initData(true);
      this.scroll(this, this.$refs.invoiceStoreScroll);
    },
    beforeDestroy() {
      // 清除事件
      // this.$refs.invoiceStoreScroll.onscroll = null;
    },
    destroyed() {
    }
  }
</script>

<style scoped lang='less'>

  .invoiceStore {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background: #FFFFFF;
    color: #000000;
    width: 70vw;
    height: 100%;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    ul, ol {
      list-style: none; /* 清除列表项前的标记（如圆点或方块） */
      padding: 0; /* 清除列表的内边距 */
      margin: 0; /* 清除列表的外边距 */
    }
    div.headBox{
      padding: 30px;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(0,0,0,0.3);
      padding-right: 20px;
    }
    div.mainBox{
      flex: 1;
      background: #F5F5F7;
      overflow-y: scroll;
      padding: 30px;
      padding-right: 20px;
      div.detailInfo{
        table {
          table-layout: fixed;
          tr {
            td {
              white-space:nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &:first-child{
                width: 200px;
              }
              &:nth-child(3){
                width: 160px;
              }
              &:nth-child(4){
                width: 110px;
              }
            }
          }
        }
      }
      div.checkGoodsBox{
        table {
          table-layout: fixed;
          tr {
            td {
              white-space:nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              &:first-child{
                width: 35px;
              }
              &:nth-child(2){
                width: 100px;
              }
              &:nth-child(3){
                width: 190px;
              }
              &:nth-child(5){
                width: 160px;
              }
              &:nth-child(6){
                width: 110px;
              }
            }
          }
        }
      }
      div.checkBox{
        table {
          tr {
            td {
              white-space:nowrap;
              &:first-child {
              }
            }
          }
        }
      }
      div.searchBox{
        margin-bottom: 20px;
        display: flex;
        div.box{
          flex: 1;
          margin-right: 15px;
          &:last-child{
            margin: 0;
          }
          &.riqi{
            flex: auto;
            width: 70px;
            div.zujian{
              position: relative;
              .vue-daterange-picker{
                width: 100%;
              }
              i.clear{
                position: absolute;
                right: 5px;
                top: 8px;
                color: rgba(0,0,0,0.4);
                cursor: pointer;
                &:hover{
                  color: rgba(0,0,0,1);
                }
              }
            }
          }
        }
      }
      div.jiazaiBox{
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 30vh;
        .spinner-border{
          width: 3rem;
          height: 3rem;
          color: red;
        }
      }
      div.emptyBox{
        background: #FFFFFF;
        min-height: 80vh;
        display: flex;
        justify-content: center;
        align-items: center;
        i{
          font-size:86px;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .invoiceStore{
      width: 70vw;
    }
  }

  @media (max-width: 992px) {
    .invoiceStore{
      width: 90vw;
    }
  }

  @media (max-width: 776px) {
    .invoiceStore{
      width: 90vw;
      div.searchBox{
        flex-direction: column;
        div.box{
          margin-right: 0;
          margin-bottom: 10px;
          &:last-child{
            button.btn{
              width: 100%;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/invoice/Store.vue